import axios from 'axios'
import { API_URL } from '../../../../../constants'
import { ApiResponse } from '../../../../common/api/response.types'
import {
  CreateMerchantBody,
  CreateMerchantData,
  IMerchant,
  IMerchantsListRes,
  LinkableUser,
  MerchantsListParams,
  PlatformLookupOption,
  PsTeamOption,
} from './types'

export const getMerchantList = (params?: MerchantsListParams) => {
  return axios.get<IMerchantsListRes>(`${API_URL}/api/internal/merchant/list`, { params })
}

const FILTER_OPTIONS_PER_PAGE = 100 // потолок EntityListRequest::MAX_PER_PAGE
const FILTER_OPTIONS_MAX_PAGES = 20

/**
 * Опции мультифильтра по мерчантам (CPAYMENT-1738). Берём именно этот список, а не
 * /api/merchant/lookup-with-token: тот отдаёт только `enabled = true`, и на вкладке
 * «Только отключенные» выбирать было бы не из чего.
 */
export const getMerchantFilterOptions = async (): Promise<IMerchant[]> => {
  const merchants: IMerchant[] = []

  for (let page = 1; page <= FILTER_OPTIONS_MAX_PAGES; page++) {
    const response = await getMerchantList({ page, perPage: FILTER_OPTIONS_PER_PAGE })

    if (!response.data?.success) {
      break
    }

    merchants.push(...(response.data.merchants ?? []))

    if (merchants.length >= (response.data.totalRows ?? 0)) {
      break
    }
  }

  return merchants
}

// --- Create-merchant wizard (CPAYMENT-1450) ---

export const createMerchant = (body: CreateMerchantBody) =>
  axios.post<ApiResponse<CreateMerchantData>>(`${API_URL}/api/internal/merchant`, body)

export const getPlatformLookup = () =>
  axios.get<ApiResponse<PlatformLookupOption[]>>(`${API_URL}/api/internal/platform/lookup`)

// Без merchantId (визард) — все привязываемые пользователи; с merchantId (карточка мерчанта,
// CPAYMENT-1625) — только операторы и ст. операторы, ещё не привязанные к этому мерчанту.
export const getLinkableUsers = (merchantId?: number) =>
  axios.get<ApiResponse<LinkableUser[]>>(`${API_URL}/api/internal/merchant/linkable-users`, {
    params: merchantId === undefined ? undefined : {merchantId},
  })

export const getPsTeamList = () =>
  axios.get<ApiResponse<PsTeamOption[]>>(`${API_URL}/api/internal/ps-team`)
